"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Env = void 0;
var three_1 = require("three");
var Env = /** @class */ (function () {
    function Env(base) {
        this.base = base;
        this.setLights();
    }
    Env.prototype.setLights = function () {
        this.setAmbientLight();
        this.setPointLight();
        this.setDirectionalLight();
    };
    Env.prototype.setPointLight = function () {
        this.pointLight = new three_1.PointLight(0x2b41a1, 3.5);
        this.pointLight.position.set(5, -2, -1);
        this.base.scene.add(this.pointLight);
    };
    Env.prototype.setDirectionalLight = function () {
        this.directionalLight = new three_1.DirectionalLight(0xfae598, 4);
        this.directionalLight.position.set(-3, 2, 2);
        this.base.scene.add(this.directionalLight);
    };
    Env.prototype.setAmbientLight = function () {
        this.ambientLight = new three_1.AmbientLight(0xfae598, 0.6);
        this.base.scene.add(this.ambientLight);
    };
    Env.prototype.update = function (clock) {
    };
    return Env;
}());
exports.Env = Env;
